<template>
  <!-- 产品设置 -->
  <div class="product-config">
    <div class="top-title-box">
      <i class="iconfont icongouxuan"></i>
      <div class="title-text">
        <div class="title-box">
          <span class="title">平台产品对下结算规则自动从上游同步</span>
          <div class="right-box">
            <i-switch v-model="formData.synchroniSettleRule" true-value="1" false-value="0" @on-change="changeSubmit" size="large" />
          </div>
        </div>
        <span class="text">开启此开关，您对下的平台产品结算规则将自动从上游同步，同步范围包含平台的新产品以及平台产品结算规则的更新。但如果您单独修改了对下结算规则，该产品后续如有更新将不再同步到您的对下结算规则里。关闭此开关，您对下的平台产品结算规则不自动从上游同步，需自行创建</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {},
    };
  },

  created() {
    this.getUserInfo()
  },

  methods: {
    getUserInfo(){
      this.$http({
        url: '/system/info/userinfo',
        type: 'GET',
        data: {}
      }).then((res) => {
        const userInfo = res.data;
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
        this.formData = {
          id: userInfo.tenantId,
          synchroniSettleRule: userInfo.synchroniSettleRule
        }
      });
    },
    // 提交
    changeSubmit() {
      this.$http({
        url: '/buz/merchantBase/update/synchroniSettleRule',
        type: 'POST',
        data: this.formData
      }).then(() => {
        this.$notice.success('操作成功')
        this.getUserInfo();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-config {
  position: relative;
  .top-title-box {
    margin-top: 20px;
    height: 80px;
    display: flex;
    border-radius: 4px;
    padding: 0 20px;
    .iconfont {
      font-size: 20px;
      color: #f6a229;
    }
    .title-text {
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      width: 100%;
      .title-box {
        font-size: 20px;
        color: #6a5041;
        margin-top: 1px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .text {
        font-size: 16px;
        color: #6a5041;
        margin-top: 20px;
        width: 68vw;
        text-align: justify;
      }
      .right-box {
        width: calc(30vw - 160px);
      }
    }
  }
}
</style>
